const centre = () => import("@/pages/breed/batch/batch.vue");
const batchMarks = () => import("@/pages/breed/batchMarks/batchMarks.vue");
const compStep = () => import("@/pages/breed/compStep/compStep.vue");
const compStepDetail = () => import("@/pages/breed/compStepDetail/compStepDetail.vue");
const step = () => import("@/pages/breed/step/step.vue");
const stepField = () => import("@/pages/breed/stepField/stepField.vue");
const traceLog = () => import("@/pages/breed/traceLog/traceLog.vue");
const breedTargInfo = () => import("@/pages/breed/breedTargInfo/breedTargInfo");
const breedPedigree = () => import("@/pages/breed/breedPedigree/breedPedigree");

const breedHouse = () => import("@/pages/breed/breedHouse/breedHouse");
export default [
    {
      path: "/nysy/breed/batch",
      name: "centre",
      component: centre,
      meta: {
        title: "日常养殖",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/batch/marks",
      name: "batchMarks",
      component: batchMarks,
      meta: {
        title: "身份码管理",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/step",
      name: "compStep",
      component: compStep,
      meta: {
        title: "企业步骤管理",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/step/detail",
      name: "compStepDetail",
      component: compStepDetail,
      meta: {
        title: "企业步骤明细",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/step",
      name: "step",
      component: step,
      meta: {
        title: "标椎步骤配置",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/step/field",
      name: "stepField",
      component: stepField,
      meta: {
        title: "标椎步骤详细配置",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/trace/log",
      name: "traceLog",
      component: traceLog,
      meta: {
        title: "溯源查询日志",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/breedTargInfo",
      name: "breedTargInfo",
      component: breedTargInfo,
      meta: {
        title: "生产批次耳标信息",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/step/detail/breedPedigree",
      name: "breedPedigree",
      component: breedPedigree,
      meta: {
        title: "打耳标",
        noCache: true,
        affix: true
      }
    },
    {
      path: "/nysy/breed/comp/step/detail/breedHouse",
      name: "breedHouse",
      component: breedHouse,
      meta: {
        title: "羊入舍",
        noCache: true,
        affix: true
      }
    },
]


// WEBPACK FOOTER //
// ./src/router/breed-route.js